
import Vue from 'vue';

import {
  validatorTypes,
  ValidatorValueType,
} from '../../constants/validatorTypes';

import { CvToastNotification } from '@carbon/vue';
import { mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';

type ColorStatusType = 'success' | 'warning' | 'error';
type ErrorFlagType = 0 | 1;

export default Vue.extend({
  components: {
    CvToastNotification,
  },

  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    msg: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isVisible: true,
    };
  },

  computed: {
    ...mapState(useProductStore, ['selectedPrintPosition']),
    type(): ValidatorValueType {
      return ((dict) => {
        return (
          dict[this.data.validatorName as keyof typeof dict] ||
          this.data.validatorName
        );
      })({
        fileTypeValidator: validatorTypes.fileTypeValidator,
        resolutionValidator: validatorTypes.resolutionValidator,
        spotColorsValidator: validatorTypes.spotColorsValidator,
        maxNumberOfColoursValidator: validatorTypes.maxNumberOfColoursValidator,
        vectorFileValidator: validatorTypes.vectorFileValidator,
        commercialRemark: validatorTypes.commercialRemark,
      });
    },
    outcome(): number {
      if (this.data.validatorColor === 'Green') {
        return 0;
      }
      if (this.data.validatorColor === 'Red') {
        return 1;
      }
      return 2;
    },

    kind(): ColorStatusType {
      return {
        Green: 'success',
        Orange: 'warning',
        Red: 'error',
      }[
        this.data.validatorColor as 'Green' | 'Orange' | 'Red'
      ] as ColorStatusType;
    },

    errorFlag(): ErrorFlagType {
      return this.kind === 'error' ? 0 : 1;
    },
  },
});
